import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { storage } from 'helpers';

export const VKNContext = createContext();

class VKNProvider extends React.Component {
  constructor(props) {
    super(props);
    let merchDefault = null;
    const merchFromLocalStorage = storage.get('merch');
    if (!merchFromLocalStorage) {
      const user = storage.getUserInfo();
      merchDefault = {
        identifier: user?.merchantInfos[0]?.identifier,
        vkn: user?.merchantInfos[0]?.number,
      };
      storage.set(merchDefault, 'merch');
    }

    this.state = {
      merch: merchFromLocalStorage || merchDefault,
    };
  }

  changeVKN = (merch) => {
    storage.set(merch, 'merch');
    this.setState({ merch });
  };

  getContextValue = () => {
    return {
      ...this.state,
      changeVKN: this.changeVKN,
    };
  };

  render() {
    const { children } = this.props;

    return <VKNContext.Provider value={this.getContextValue()}>{children}</VKNContext.Provider>;
  }
}

VKNProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const { Consumer } = VKNContext;
export const Provider = VKNProvider;
